import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCheckBoxFilled = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18 3H6Q3 3 3 6v12q0 3 3 3h12q3 0 3-3V6q0-3-3-3m-6.26 12.574a1 1 0 0 1-1.528.04l-2.586-2.91a1 1 0 0 1 .04-1.37l.06-.06a1 1 0 0 1 1.475.067L11 13.5l3.808-5.078a1 1 0 0 1 1.507-.107l.052.052a1 1 0 0 1 .074 1.332z"
    }));
export default SvgCheckBoxFilled;
